﻿import axios from 'axios'
import type { EventDto } from '@/types'

const path = `${import.meta.env.VITE_CONTENT_API}/events`
export async function getEventById(id: number) {
    const { data } = await axios.get<EventDto>(`${path}/${id}`)
    return deserializeEvent(data)
}
export async function getAllEvents() {
    const { data } = await axios.get<EventDto[]>(`${path}`)
    return data.map(deserializeEvent)
}
export async function getEventsForCreator(creatorId: number, creatorPartitionKey: string) {
    const { data } = await axios.get<EventDto[]>(`${path}/Creator/${creatorPartitionKey}/${creatorId}`)
    return data.map(deserializeEvent)
}
export async function createEvent(event: EventDto, image?: File) {
    const formData = new FormData()
    var ev = JSON.stringify(event);
    formData.append(
        'event',
        new Blob([JSON.stringify(event)], {
            type: 'application/json'
        })
    )
    if (image) {
        formData.append('image', image)
    }
    const { data } = await axios.post<EventDto>(`${path}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
    return deserializeEvent(data)
}
export async function updateEvent(event: EventDto) {
    const { data } = await axios.put<EventDto>(`${path}`, event)
    return deserializeEvent(data)
}
export async function apiPublishEvent(event: EventDto, userId:string, userEmail:string) {
    await axios.get(`${path}/${event.id}/publish?userId=${userId}&userEmail=${userEmail}`)   
}

export async function deleteEventById(id: number, partitionKey: string) {
    await axios.delete(`${path}/${id}/${partitionKey}`)
}
function deserializeEvent(event: EventDto) {

    event.start = event.start ? new Date(event.start) : undefined
    event.end = event.end ? new Date(event.end) : undefined
    event.publish = event.publish ? new Date(event.publish) : undefined
    return event
}
